const PlanOdooSoView = ({ planLines, odooLinesWithNotFoundInPlanLines }) => {
  console.log(
    "odooLinesWithNotFoundInPlanLines",
    odooLinesWithNotFoundInPlanLines,
  );

  return (
    <table>
      <thead>
        <tr className="whitespace-nowrap">
          <th>Product</th>
          <th className="text-right">Price</th>
          <th className="text-right text-purple-600">Odoo QTY</th>
          <th className="text-right">Plan QTY</th>
        </tr>
      </thead>
      <tbody>
        {planLines.map((line, planLineIndex) => (
          <tr
            key={planLineIndex}
            className={`border-b dark:border-gray-700
                       ${line.qty !== line.odooTotalQty ? "text-red-600" : ""}`}
          >
            <td>
              {planLineIndex + 1}. [{line.product.number}] {line.product.name}
            </td>
            <td className="text-right">{line.salesPrice.toFixed(2)}</td>
            <td className="text-right">{line.odooTotalQty}</td>
            <td className="text-right">{line.qty}</td>
          </tr>
        ))}
        {odooLinesWithNotFoundInPlanLines.length > 0 && (
          <>
            <tr>
              <td colSpan={4} className="text-sm text-red-600 font-semibold">
                ⚠️ Below are the lines in Odoo but not found in the plan. Wis
                will not delete them, you might want to update in odoo manually.
              </td>
            </tr>

            {odooLinesWithNotFoundInPlanLines.map((line, odooLineindex) => (
              <tr key={odooLineindex} className={`border-y text-red-600`}>
                <td>
                  {odooLineindex + 1}.{" "}
                  {line.product_id?.display_name || line.name}
                </td>
                <td className="text-right">{line.price_unit.toFixed(2)}</td>
                <td className="text-right">{line.product_uom_qty}</td>
                <td className="text-right">0</td>
              </tr>
            ))}
          </>
        )}
      </tbody>
    </table>
  );
};

export default PlanOdooSoView;
